
<div class="modal-body" [class.text-center]="option.align === 'center'">
  <p [innerHTML]="option.message"></p>
</div>
<div class="modal-footer" [class.justify-content-center]="option.align === 'center'">
  <button *ngIf="!option.hideBack" type="button" class="btn btn-bg-empty px-5 mr-3"
    (click)="close(false)">{{option.backButton || 'Annulla'}}</button>
  <button type="button" class="btn btn-bg-full px-5"(click)="close(true)">{{option.button || "Avanti"}}</button>
</div>
